import { z } from 'zod';

import { BrandMemberSchema } from './brand-user';
import { makeEndpoint } from '../common';

export const BrandHostSchema = BrandMemberSchema.pick({
  id: true,
  firstName: true,
  lastName: true,
  profilePicture: true,
  emailAddress: true,
  description: true,
});

const BrandResponseSchema = z.object({
  items: z.array(BrandHostSchema),
});

export const PublicBrandHostEndpoint = makeEndpoint({
  url: () => `/v1/hosts`,
  method: 'GET',
  responseSchema: BrandResponseSchema,
  requestSchema: z.void(),
});
